import { FormEvent, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Heart, Star } from "@/components/Doodles";
import { BRAND } from "@/lib/site";

export default function LoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <section className="relative hidden overflow-hidden bg-[#F6D776] p-14 lg:flex lg:flex-col lg:justify-between">
        <Star className="absolute right-20 top-24 h-20 w-20 rotate-12" color="#FFFFFF" />
        <Heart className="absolute bottom-40 right-40 h-16 w-16 -rotate-12" />
        <Star className="absolute bottom-16 left-24 h-12 w-12 -rotate-6" color="#9CC9E8" />
        <p className="flex items-center gap-2 font-heading text-xl font-semibold text-[#23324A]"><img src="/logo/everyday.png" alt="" className="h-9 w-9" />{BRAND}</p>
        <div className="fade-up">
          <h1 className="font-heading text-5xl font-semibold leading-[1.05] text-[#23324A] xl:text-6xl">Gifts worth<br /><em className="text-[#D9785C]">making.</em></h1>
          <p className="mt-6 max-w-md text-base text-[#23324A]/80">The product engine: build printables, write listings, review on your phone and send drafts to Etsy.</p>
        </div>
        <p className="text-sm font-semibold text-[#23324A]/70">Owner access only</p>
      </section>
      <section className="flex items-center px-6 py-16 sm:px-16">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <p className="mb-2 font-display text-lg font-black text-[#23324A] lg:hidden">{BRAND}</p>
          <h2 className="font-display text-3xl font-black text-[#23324A]">Welcome back, Kelly</h2>
          <p className="mb-8 mt-2 text-sm text-[#23324A]/70">Sign in to your product engine.</p>
          <label className="mb-2 block text-sm font-bold text-[#23324A]" htmlFor="email">Email</label>
          <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field mb-5" data-testid="login-email-input" autoComplete="email" />
          <label className="mb-2 block text-sm font-bold text-[#23324A]" htmlFor="password">Password</label>
          <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field mb-6" data-testid="login-password-input" autoComplete="current-password" />
          {error && <p className="mb-4 rounded-xl border-2 border-[#F08A6C] bg-[#FDE6DF] px-3 py-2 text-sm font-semibold text-[#23324A]" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn-coral w-full" data-testid="login-submit-button">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
      </section>
    </div>
  );
}
